// extracted by mini-css-extract-plugin
module.exports = {"button":"KtPrintQrButton_button__2vqJW","text":"KtPrintQrButton_text__xm9RK","text-ltr":"KtPrintQrButton_text-ltr__2Sev2"};